<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <!-- <h5>Approval Edit Gadai Elektronik</h5> -->
                <h5>Approval Edit Gadai</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA ANGGOTA</h6>
                    <div class="detail-data-wrapper mb-4">
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                            <b-col v-if="dataEditGadaiElek.anggota.noAnggota != null"><strong>{{ dataEditGadaiElek.anggota.noAnggota }}</strong></b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. KTP</b-col>
                            <b-col v-if="dataEditGadaiElek.anggota.noIdentitas != null">{{ dataEditGadaiElek.anggota.noIdentitas }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Nama</b-col>
                            <b-col v-if="dataEditGadaiElek.anggota.namaAnggota != null">{{ dataEditGadaiElek.anggota.namaAnggota }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Alamat</b-col>
                            <b-col v-if="dataEditGadaiElek.anggota.alamat != null">{{ dataEditGadaiElek.anggota.alamat }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                            <b-col v-if="dataEditGadaiElek.anggota.noHp != null">{{ dataEditGadaiElek.anggota.noHp }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                    </div>
                </div>
                <div class="form-content-wrapper" v-if="dataEditGadaiElek.barangBaru.kendaraan == null">
                    <h6 class="form-title">DATA BARANG</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Barang</div>
                                <div v-if="dataEditGadaiElek.barangLama.jenis.name != null">{{ dataEditGadaiElek.barangLama.jenis.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Barang</div>
                                <div v-if="dataEditGadaiElek.barangLama.merk.name != null">{{ dataEditGadaiElek.barangLama.merk.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Barang</div>
                                <div v-if="dataEditGadaiElek.barangLama.tipe.name != null">{{ dataEditGadaiElek.barangLama.tipe.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tahun / Generasi</div>
                                <div v-if="dataEditGadaiElek.barangLama.tahun != null">{{ dataEditGadaiElek.barangLama.tahun }}</div>
                                <div v-else>-</div>
                            </div>
                            <div v-if="dataEditGadaiElek.barangLama.laptop != null" class="mb-2">
                                <div class="detail-data-label">Spesifikasi Laptop</div>
                                <div>{{ dataEditGadaiElek.barangLama.laptop.spesifikasiLaptop }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi / Grade Barang</div>
                                <div v-if="dataEditGadaiElek.barangLama.gradeKondisi.name != null">{{ dataEditGadaiElek.barangLama.gradeKondisi.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div v-if="dataEditGadaiElek.barangLama.laptop != null" class="mb-2">
                                <div class="detail-data-label">RAM Laptop</div>
                                <div>{{ dataEditGadaiElek.barangLama.laptop.ram }} GB</div>
                            </div>
                            <div v-if="dataEditGadaiElek.barangLama.laptop != null" class="mb-2">
                                <div class="detail-data-label">Hardisk Laptop</div>
                                <div>{{ dataEditGadaiElek.barangLama.laptop.gadaiJenisHardisk }} {{ dataEditGadaiElek.barangLama.laptop.gadaiSizeHardisk }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. IMEI/SN</div>
                                <div v-if="dataEditGadaiElek.barangLama.noImei != null">{{ dataEditGadaiElek.barangLama.noImei }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Password</div>
                                <div v-if="dataEditGadaiElek.barangLama.password != null">{{ dataEditGadaiElek.barangLama.password }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Warna</div>
                                <div v-if="dataEditGadaiElek.barangLama.warna.name != null">{{ dataEditGadaiElek.barangLama.warna.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi/ Kerusakan/ Keterangan Lainnya</div>
                                <div v-if="dataEditGadaiElek.barangLama.keterangan != null && dataEditGadaiElek.barangLama.keterangan != 'null'">{{ dataEditGadaiElek.barangLama.keterangan }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kelengkapan Barang</div>
                                <div v-if="dataEditGadaiElek.barangLama.kelengkapan.length != 0">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="item in dataEditGadaiElek.barangLama.kelengkapan"  v-bind:key="item">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Barang</div>
                                <div v-if="dataEditGadaiElek.barangLama.spesifikasi.length >=1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataEditGadaiElek.barangLama.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Barang</div>
                                <div v-if="dataEditGadaiElek.barangBaru.jenis.name != null">{{ dataEditGadaiElek.barangBaru.jenis.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Barang</div>
                                <div v-if="dataEditGadaiElek.barangBaru.merk.name != null">{{ dataEditGadaiElek.barangBaru.merk.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Barang</div>
                                <div v-if="dataEditGadaiElek.barangBaru.tipe.name != null">{{ dataEditGadaiElek.barangBaru.tipe.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tahun / Generasi</div>
                                <div v-if="dataEditGadaiElek.barangBaru.tahun != null">{{ dataEditGadaiElek.barangBaru.tahun }}</div>
                                <div v-else>-</div>
                            </div>
                            <div v-if="dataEditGadaiElek.barangBaru.laptop != null" class="mb-2">
                                <div class="detail-data-label">Spesifikasi Laptop</div>
                                <div>{{ dataEditGadaiElek.barangBaru.laptop.spesifikasiLaptop }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi / Grade Barang</div>
                                <div v-if="dataEditGadaiElek.barangBaru.gradeKondisi.name != null">{{ dataEditGadaiElek.barangBaru.gradeKondisi.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div v-if="dataEditGadaiElek.barangBaru.laptop != null" class="mb-2">
                                <div class="detail-data-label">RAM Laptop</div>
                                <div>{{ dataEditGadaiElek.barangBaru.laptop.ram }} GB</div>
                            </div>
                            <div v-if="dataEditGadaiElek.barangBaru.laptop != null" class="mb-2">
                                <div class="detail-data-label">Hardisk Laptop</div>
                                <div>{{ dataEditGadaiElek.barangBaru.laptop.gadaiJenisHardisk }} {{ dataEditGadaiElek.barangBaru.laptop.gadaiSizeHardisk }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. IMEI/SN</div>
                                <div v-if="dataEditGadaiElek.barangBaru.noImei != null">{{ dataEditGadaiElek.barangBaru.noImei }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Password</div>
                                <div v-if="dataEditGadaiElek.barangBaru.password != null">{{ dataEditGadaiElek.barangBaru.password }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Warna</div>
                                <div v-if="dataEditGadaiElek.barangBaru.warna.name != null">{{ dataEditGadaiElek.barangBaru.warna.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi/ Kerusakan/ Keterangan Lainnya</div>
                                <div v-if="dataEditGadaiElek.barangBaru.keterangan != null && dataEditGadaiElek.barangBaru.keterangan != 'null'">{{ dataEditGadaiElek.barangBaru.keterangan }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kelengkapan Barang</div>
                                <div v-if="dataEditGadaiElek.barangBaru.kelengkapan.length != 0">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="item in dataEditGadaiElek.barangBaru.kelengkapan"  v-bind:key="item">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Barang</div>
                                <div v-if="dataEditGadaiElek.barangBaru.spesifikasi.length >=1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataEditGadaiElek.barangBaru.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <div v-else>
                    <div class="form-content-wrapper">
                        <h6 class="form-title">DATA KENDARAAN</h6>
                        <b-row>
                            <b-col lg="4" md="6" cols="6">
                                <h6 class="compare-text-title">Data Sekarang</h6>
                                <div class="mb-2">
                                    <div class="detail-data-label">Tipe Pinjaman</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.withKendaraan == true">Kendaraan + BPKB</div>
                                    <div v-else>BPKB Saja</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Jenis Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangLama.jenis != null">{{ dataEditGadaiElek.barangLama.jenis.name }}</div>
                                    <div v-else>-</div>    
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Merk Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangLama.merk != null">{{ dataEditGadaiElek.barangLama.merk.name }}</div>
                                    <div v-else>-</div>           
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Tipe Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangLama.tipe != null">{{ dataEditGadaiElek.barangLama.tipe.name }}</div>
                                    <div v-else>-</div>              
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Tahun</div>
                                    <div v-if="dataEditGadaiElek.barangLama.tahun != null">{{ dataEditGadaiElek.barangLama.tahun }}</div>
                                    <div v-else>-</div>              
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Kondisi / Grade Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangLama.gradeKondisi != null">{{ dataEditGadaiElek.barangLama.gradeKondisi.name }}</div>
                                    <div v-else>-</div>       
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Warna Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangLama.warna != null">{{ dataEditGadaiElek.barangLama.warna.name }}</div>
                                    <div v-else>-</div>                 
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Status Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.status != null">{{ dataEditGadaiElek.barangLama.kendaraan.status }}</div>
                                    <div v-else>-</div>                    
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">No. Polisi</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.noPolisi != null">{{ dataEditGadaiElek.barangLama.kendaraan.noPolisi }}</div>
                                    <div v-else>-</div>                
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Kelengkapan Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kelengkapan.length >= 1">
                                        <ul class="list-circle-wrapper">
                                            <li v-for="item in dataEditGadaiElek.barangLama.kelengkapan"  v-bind:key="item">
                                                {{ item }}
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else>-</div>    
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Spesifikasi Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangLama.spesifikasi.length >= 1">
                                        <ul class="list-circle-wrapper">
                                            <li v-for="(item, idx) in dataEditGadaiElek.barangLama.spesifikasi"  v-bind:key="idx">
                                                {{ item.name }}
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else>-</div>             
                                </div>
                            </b-col>
                            <b-col lg="4" md="6" cols="6" class="comparison-separator">
                                <h6 class="compare-text-title">Data Perubahan</h6>
                                <div class="mb-2">
                                    <div class="detail-data-label">Tipe Pinjaman</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.withKendaraan == true">Kendaraan + BPKB</div>
                                    <div v-else>BPKB Saja</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Jenis Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.jenis != null">{{ dataEditGadaiElek.barangBaru.jenis.name }}</div>
                                    <div v-else>-</div>    
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Merk Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.merk != null">{{ dataEditGadaiElek.barangBaru.merk.name }}</div>
                                    <div v-else>-</div>           
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Tipe Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.tipe != null">{{ dataEditGadaiElek.barangBaru.tipe.name }}</div>
                                    <div v-else>-</div>              
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Tahun</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.tahun != null">{{ dataEditGadaiElek.barangBaru.tahun }}</div>
                                    <div v-else>-</div>              
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Kondisi / Grade Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.gradeKondisi != null">{{ dataEditGadaiElek.barangBaru.gradeKondisi.name }}</div>
                                    <div v-else>-</div>       
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Warna Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.warna != null">{{ dataEditGadaiElek.barangBaru.warna.name }}</div>
                                    <div v-else>-</div>                 
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Status Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.status != null">{{ dataEditGadaiElek.barangBaru.kendaraan.status }}</div>
                                    <div v-else>-</div>                    
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">No. Polisi</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.noPolisi != null">{{ dataEditGadaiElek.barangBaru.kendaraan.noPolisi }}</div>
                                    <div v-else>-</div>                
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Kelengkapan Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kelengkapan.length >= 1">
                                        <ul class="list-circle-wrapper">
                                            <li v-for="item in dataEditGadaiElek.barangBaru.kelengkapan"  v-bind:key="item">
                                                {{ item }}
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else>-</div>    
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Spesifikasi Kendaraan</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.spesifikasi.length >= 1">
                                        <ul class="list-circle-wrapper">
                                            <li v-for="(item, idx) in dataEditGadaiElek.barangBaru.spesifikasi"  v-bind:key="idx">
                                                {{ item.name }}
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else>-</div>             
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="detail-data-wrapper mb-4">
                        <h6 class="form-title">DATA STNK</h6>
                        <b-row>
                            <b-col lg="4" md="6" cols="6">
                                <h6 class="compare-text-title">Data Sekarang</h6>
                                <div class="mb-2">
                                    <div class="detail-data-label">STNK Atas Nama</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.namaSTNK != null">{{ dataEditGadaiElek.barangLama.kendaraan.namaSTNK }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kota STNK</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.kotaSTNK != null">{{ dataEditGadaiElek.barangLama.kendaraan.kotaSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kecamatan STNK</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.kecamatanSTNK != null">{{ dataEditGadaiElek.barangLama.kendaraan.kecamatanSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kelurahan STNK</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.kelurahanSTNK != null">{{ dataEditGadaiElek.barangLama.kendaraan.kelurahanSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">RT</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.rtSTNK != null">{{ $helper.formatThreeDigitNumber(dataEditGadaiElek.barangLama.kendaraan.rtSTNK) }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">RW</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.rwSTNK != null">{{ $helper.formatThreeDigitNumber(dataEditGadaiElek.barangLama.kendaraan.rwSTNK) }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Alamat STNK</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.alamatSTNK != null">{{ dataEditGadaiElek.barangLama.kendaraan.alamatSTNK }}</div>
                                    <div v-else>-</div>              
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Masa berlaku pajak STNK</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.pajakSTNK != null">{{$helper.changeDateFormat(dataEditGadaiElek.barangLama.kendaraan.pajakSTNK) }}</div>
                                    <div v-else>-</div>                        
                                </div>
                            </b-col>
                            <b-col lg="4" md="6" cols="6" class="comparison-separator">
                                <h6 class="compare-text-title">Data Perubahan</h6>
                                <div class="mb-2">
                                    <div class="detail-data-label">STNK Atas Nama</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.namaSTNK != null">{{ dataEditGadaiElek.barangBaru.kendaraan.namaSTNK }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kota STNK</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.kotaSTNK != null">{{ dataEditGadaiElek.barangBaru.kendaraan.kotaSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kecamatan STNK</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.kecamatanSTNK != null">{{ dataEditGadaiElek.barangBaru.kendaraan.kecamatanSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kelurahan STNK</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.kelurahanSTNK != null">{{ dataEditGadaiElek.barangBaru.kendaraan.kelurahanSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">RT</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.rtSTNK != null">{{ $helper.formatThreeDigitNumber(dataEditGadaiElek.barangBaru.kendaraan.rtSTNK) }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">RW</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.rwSTNK != null">{{ $helper.formatThreeDigitNumber(dataEditGadaiElek.barangBaru.kendaraan.rwSTNK) }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Alamat STNK</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.alamatSTNK != null">{{ dataEditGadaiElek.barangBaru.kendaraan.alamatSTNK }}</div>
                                    <div v-else>-</div>              
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Masa berlaku pajak STNK</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.pajakSTNK != null">{{$helper.changeDateFormat(dataEditGadaiElek.barangBaru.kendaraan.pajakSTNK) }}</div>
                                    <div v-else>-</div>                        
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="detail-data-wrapper mb-4">
                        <h6 class="form-title">DATA BPKB</h6>
                        <b-row>
                            <b-col lg="4" md="6" cols="6">
                                <h6 class="compare-text-title">Data Sekarang</h6>
                                <div class="mb-2">
                                    <div class="detail-data-label">No. BPKB</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.noBPKB != null">{{ dataEditGadaiElek.barangLama.kendaraan.noBPKB }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">BPKB Atas Nama</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.namaBPKB != null">{{ dataEditGadaiElek.barangLama.kendaraan.namaBPKB }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">No. Mesin</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.noMesin != null">{{ dataEditGadaiElek.barangLama.kendaraan.noMesin }}</div>
                                    <div v-else>-</div>             
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">No. Rangka</div>
                                    <div v-if="dataEditGadaiElek.barangLama.kendaraan.noRangka != null">{{ dataEditGadaiElek.barangLama.kendaraan.noRangka }}</div>
                                    <div v-else>-</div>
                                </div>
                            </b-col>
                            <b-col lg="4" md="6" cols="6" class="comparison-separator">
                                <h6 class="compare-text-title">Data Perubahan</h6>
                                <div class="mb-2">
                                    <div class="detail-data-label">No. BPKB</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.noBPKB != null">{{ dataEditGadaiElek.barangBaru.kendaraan.noBPKB }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">BPKB Atas Nama</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.namaBPKB != null">{{ dataEditGadaiElek.barangBaru.kendaraan.namaBPKB }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">No. Mesin</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.noMesin != null">{{ dataEditGadaiElek.barangBaru.kendaraan.noMesin }}</div>
                                    <div v-else>-</div>             
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">No. Rangka</div>
                                    <div v-if="dataEditGadaiElek.barangBaru.kendaraan.noRangka != null">{{ dataEditGadaiElek.barangBaru.kendaraan.noRangka }}</div>
                                    <div v-else>-</div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PERHITUNGAN</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Harga Barang</div>
                                <div v-if="dataEditGadaiElek.perhitunganLama.hargaBarang != null">Rp. {{ $helper.addThousandSeparator(dataEditGadaiElek.perhitunganLama.hargaBarang) }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Pinjaman Maksimal</div>
                                <div v-if="dataEditGadaiElek.perhitunganLama.pinjamanMaksimal != null">Rp. {{ $helper.addThousandSeparator(dataEditGadaiElek.perhitunganLama.pinjamanMaksimal) }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Taksiran Harga</div>
                                <div v-if="dataEditGadaiElek.perhitunganLama.taksiranHarga != null">Rp. {{ $helper.addThousandSeparator(dataEditGadaiElek.perhitunganLama.taksiranHarga) }}</div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">
                                Data Perubahan
                                <i class="fa fa-info tooltip-trigger-btn ml-1" id="tooltip-data-perubahan"></i>
                                <b-tooltip target="tooltip-data-perubahan" triggers="hover">
                                    Hitungan Pinjaman Maksimal dan Taksiran Harga tidak menghitung promo dan adjustment status anggota yang didapatkan pada saat penggadaian
                                </b-tooltip>
                            </h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Harga Barang</div>
                                <div v-if="dataEditGadaiElek.perhitunganBaru.hargaBarang != null">Rp. {{ $helper.addThousandSeparator(dataEditGadaiElek.perhitunganBaru.hargaBarang) }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Pinjaman Maksimal</div>
                                <div v-if="dataEditGadaiElek.perhitunganBaru.pinjamanMaksimal != null">Rp. {{ $helper.addThousandSeparator(dataEditGadaiElek.perhitunganBaru.pinjamanMaksimal) }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Taksiran Harga</div>
                                <div v-if="dataEditGadaiElek.perhitunganBaru.taksiranHarga != null">Rp. {{ $helper.addThousandSeparator(dataEditGadaiElek.perhitunganBaru.taksiranHarga) }}</div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PENDUKUNG</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataEditGadaiElek.fotoLama)" class="mt-1">
                                    <ModalFoto isButton withLength :photos="dataEditGadaiElek.fotoLama.map(foto => foto.name)" />
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataEditGadaiElek.fotoBaru)" class="mt-1">
                                    <ModalFoto isButton withLength :photos="dataEditGadaiElek.fotoBaru.map(foto => foto.name)" />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">ALASAN PERUBAHAN</h6>
                    <b-row class="mb-2">
                        <b-col cols="3" class="detail-data-label">Keterangan</b-col>
                        <b-col v-if="dataEditGadaiElek.keteranganRevisi != null">{{ dataEditGadaiElek.keteranganRevisi }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="3" class="detail-data-label">Diajukan pada</b-col>
                        <b-col>{{ $helper.changeDateFormat(dataEditGadaiElek.tanggalPengajuan )}} {{ $helper.changeDateFormatGetHour(dataEditGadaiElek.tanggalPengajuan )}}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="3" class="detail-data-label">Diajukan oleh</b-col>
                        <b-col>{{ dataEditGadaiElek.diajukanOleh }}</b-col>
                    </b-row>
                </div>
            </b-form>

            <div v-if="showApprovalEditGadai" class="detail-data-wrapper mb-4">
                <h6 class="form-title">APPROVAL EDIT GADAI</h6>
                <b-row>
                    <b-col lg="4" md="6">
                        <b-form-group label="Keterangan">
                            <b-form-textarea v-model="keteranganApproval" name="keterangan"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="cetak-sbg-btn">
                    <div class="mt-2">
                        <b-button class="mr-2" variant="pgiBtn" name="cetakBtn" @click="confirmApprove">
                            Setujui
                        </b-button>
                        <b-button variant="danger" name="cetakBtn" @click="confirmReject">
                            Tolak
                        </b-button>
                    </div>
                </div>
            </div>

            <div v-else class="detail-data-wrapper mb-4">
                <h6 class="form-title">APPROVAL EDIT GADAI</h6>
                <b-row class="mb-2">
                    <b-col cols="3" class="detail-data-label">Status Edit Gadai</b-col>
                    <b-col>{{ dataEditGadaiElek.status }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="3" class="detail-data-label">Keterangan</b-col>
                    <b-col v-if="dataEditGadaiElek.keteranganApproval != null">{{ dataEditGadaiElek.keteranganApproval }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="3" class="detail-data-label">Diproses pada</b-col>
                    <b-col>{{ $helper.changeDateFormat(dataEditGadaiElek.processedAt )}} {{ $helper.changeDateFormatGetHour(dataEditGadaiElek.processedAt )}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="3" class="detail-data-label">Diproses oleh</b-col>
                    <b-col>{{ dataEditGadaiElek.processedBy }}</b-col>
                </b-row>
            </div>
        </b-card>
        <ModalConfirm id="modal-confirm-approve" title="Confirm Approve Gadai" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menyetujui edit gadai ini?" @submit="onApprove" />
        <ModalConfirm id="modal-confirm-reject" title="Confirm Reject Gadai" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menolak edit gadai ini?" @submit="onReject" />
    </div>
</template>

<script>
import ModalFoto from '@/components/modals/ModalFoto'

export default {
    name: 'approval-edit-gadai-elektronik',
    components: {
        ModalFoto,
    },
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            keteranganApproval: "",
            approved: null,
            dataEditGadaiElek: [],
            showApprovalEditGadai: true
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            // this.initStatus = 1
            this.initStatus = 0
            this.id = this.$route.params.id
            
            let getEditGadaiElek = this.$axios.get(`approval-edit-gadai/${this.id}`).then(response => {
                this.dataEditGadaiElek = response.data
                if (this.dataEditGadaiElek.status != "PENDING") this.showApprovalEditGadai = false
            })

            Promise.all([getEditGadaiElek]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Submit Approve Edit Gadai -----------------

        onApprove(){
            let payload = new FormData()
            this.isSubmitting = true

            payload.append('id', this.id)
            payload.append('approve', this.approved)
            
            this.$axios.post("approval-edit-gadai/", payload).then(response => {
                this.$helper.setFlash("Edit Gadai berhasil disetujui!")
                this.$bvModal.hide("modal-confirm-approve")
                
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Submit Suspect Gadai -----------------

        onReject(){
            let payload = new FormData()
            this.isSubmitting = true

            payload.append('id', this.id)
            payload.append('approve', this.approved)
            payload.append('keterangan', this.keteranganApproval)
            
            this.$axios.post("approval-edit-gadai/", payload).then(response => {
                this.$helper.setFlash("Edit Gadai berhasil ditolak!")
                this.$bvModal.hide("modal-confirm-reject")
                
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        confirmApprove(){
            this.approved = true
            this.$bvModal.show("modal-confirm-approve")
        },

        confirmReject(){
            if (this.keteranganApproval == "") {
                this.$helper.toastErr(this, "Mohon masukkan keterangan di dalam kotak Keterangan!")
            } else {
                this.approved = false
                this.$bvModal.show("modal-confirm-reject")
            }
        }

        
    },
    created(){
        this.init()
    }
}
</script>
